/*eslint-disable*/
function initMap() {
    let mapArea = document.querySelector(".mapStyles");

    if (mapArea) {
        appendStylesheet("https://api.mapbox.com/mapbox-gl-js/v1.8.1/mapbox-gl.css", function() {
            let mapboxgl = require("mapbox-gl/dist/mapbox-gl.js");

            let latitude = mapArea.getAttribute("data-latitude");
            let longitude = mapArea.getAttribute("data-longitude");
            let dataZoom = window.innerWidth > 767 ? mapArea.getAttribute("data-initZoom") : (mapArea.getAttribute("data-initZoom") || 1) * 0.8;
            let initZoom = dataZoom || 0.8;
            let styleId = mapArea.getAttribute("data-styleId") || "ck87thjj4051s1ipniqys4jga";

            let obj = mapArea.getAttribute("data-json");
            let jsonReplace = obj.replace(/'/g, '"');
            let json = JSON.parse(jsonReplace);
            let disableScroll = mapArea.getAttribute("data-disable");

            mapboxgl.accessToken = "pk.eyJ1IjoiY3Jlc2NlbmRvY29sbGVjdGl2ZSIsImEiOiJjazd5emFlajkwMHBwM2VzYmVoYnp3N3BzIn0.3qxkrI33oyUX5mtaCh-JBw";
            let map = new mapboxgl.Map({
                container: "map",
                style: `mapbox://styles/crescendocollective/${styleId}`,
                center: [longitude, latitude],
                zoom: initZoom,
                maxZoom: 8,
                minZoom: 1
            });

            map.on("load", function() {
                map.addSource("points", {
                    type: "geojson",
                    data: {
                        type: "FeatureCollection",
                        features: json
                    }
                });

                map.addLayer({
                    id: "markers",
                    type: "symbol",
                    source: "points",
                    layout: {
                        "icon-image": "marker",
                        "icon-size": 0.3,
                        "icon-anchor": "bottom",
                        "icon-allow-overlap": true
                    }
                });

                map.on("click", "markers", function(e) {
                    var coordinates = e.features[0].geometry.coordinates.slice();

                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }

                    map.flyTo({
                        center: e.features[0].geometry.coordinates,
                        zoom: 3,
                        speed: 2,
                        curve: 1,
                        bearing: 0
                    });

                    var popup;
                    var hidden;
                    var div = window.document.createElement("div");
                    var hiddenDiv = window.document.createElement("div");
                    var footnote = e.features[0].properties.footnote ? `<div class=footnoteDiv>${e.features[0].properties.footnote}</div>` : `<div style="display:none"></div>`;
                    var image = e.features[0].properties.image ? `<div class="popup__image" style="background-image: url(${e.features[0].properties.image})"></div>` : "";

                    div.innerHTML = "<a href=" + e.features[0].properties.link + "><div class='popup__container'>" + image + "<div class='popup__text'><h3 class='title titleHr'>" + e.features[0].properties.title + "</h3><p>" + e.features[0].properties.description + "</p></div></div></a>";
                    popup = e.features[0].properties.image ? new mapboxgl.Popup({ className: "imageClass" }) : new mapboxgl.Popup();
                    hiddenDiv.innerHTML = footnote;

                    popup
                        .setLngLat(coordinates)
                        .setDOMContent(div)
                        .addTo(map);

                    if (footnote != "" || footnote != null) {
                        hidden = new mapboxgl.Popup({ closeButton: false })
                            .setLngLat(coordinates)
                            .setDOMContent(hiddenDiv)
                            .addTo(map);
                    }

                    var DOMfootnote = document.getElementById("footnote");
                    var footnoteContent = hidden._content;

                    function setContent(el, newParent) {
                        newParent.appendChild(el);
                    }
                    setContent(footnoteContent, DOMfootnote);

                    popup.on("close", function() {
                        hidden.remove();
                    });
                });

                map.on("mouseenter", "markers", function(e) {
                    map.getCanvas().style.cursor = "pointer";
                    var coordinates = e.features[0].geometry.coordinates.slice();

                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }

                    var popup;
                    var hidden;
                    var div = window.document.createElement("div");
                    var image = e.features[0].properties.image ? `<div class="popup__image" style="background-image: url(${e.features[0].properties.image})"></div>` : "";
                    var hiddenDiv = window.document.createElement("div");
                    var footnote = e.features[0].properties.footnote ? `<div class=footnoteDiv>${e.features[0].properties.footnote}</div>` : `<div style="display:none"></div>`;

                    hiddenDiv.innerHTML = footnote;
                    div.innerHTML = "<a href=" + e.features[0].properties.link + "><div class='popup__container'>" + image + "<div class='popup__text'><h3 class='title titleHr'>" + e.features[0].properties.title + "</h3><p>" + e.features[0].properties.description + "</p></div></div></a>";
                    popup = e.features[0].properties.image ? new mapboxgl.Popup({ className: "imageClass" }) : new mapboxgl.Popup();

                    popup
                        .setLngLat(coordinates)
                        .setDOMContent(div)
                        .addTo(map);

                    if (footnote != "" || footnote != null) {
                        hidden = new mapboxgl.Popup({ closeButton: false })
                            .setLngLat(coordinates)
                            .setDOMContent(hiddenDiv)
                            .addTo(map);
                    }

                    var DOMfootnote = document.getElementById("footnote");
                    var footnoteContent = hidden._content;

                    function setContent(el, newParent) {
                        newParent.appendChild(el);
                    }
                    setContent(footnoteContent, DOMfootnote);

                    map.on("mouseleave", "markers", function() {
                        map.getCanvas().style.cursor = "";
                        hidden.remove();
                        popup.remove();
                    });
                });
            });

            if (disableScroll === "scrollZoom") {
                map.scrollZoom.disable();
            } else {
                map.scrollZoom.enable();
            }
        });
    }
}

function appendStylesheet(href, onload = () => {}) {
    let link = document.createElement("link");
    link.rel = "stylesheet";
    link.onload = function() {
        link.onload = null;
        onload();
    };
    document.getElementsByTagName("head")[0].appendChild(link);
    link.href = href;
}

function init() {
    initMap();
}

export default { init };
